// extracted by mini-css-extract-plugin
export default {"edgeDeviceConfigPreviewTitle":"GlobalEdge_edgeDeviceConfigPreviewTitle__-xHxV"};